/**
 * Grup pengguna yang sedang masuk, dibaca dari localStorage.
 *
 * Hanya untuk menentukan TAMPILAN (menu, tombol, halaman awal). Hak akses
 * yang sesungguhnya diputuskan server; mengubah localStorage tidak membuka
 * data apa pun.
 */
export const GRUP = Object.freeze({
  OWNER: 'Owner',
  ADMIN_EVENT: 'Event PIC',
  BENDAHARA: 'Bendahara',
});

export function grupPengguna() {
  try {
    const nama = JSON.parse(localStorage.getItem('user') || '{}').group?.name || '';
    return nama === 'Admin' ? GRUP.OWNER : nama;
  } catch (e) {
    return '';
  }
}

export const isOwner = () => grupPengguna() === GRUP.OWNER;
export const isBendahara = () => grupPengguna() === GRUP.BENDAHARA;
export const isPanitia = () => [GRUP.OWNER, GRUP.ADMIN_EVENT].includes(grupPengguna());
export const isAdminEvent = () => grupPengguna() === GRUP.ADMIN_EVENT;

/** Halaman pertama setelah masuk. */
export function halamanAwal() {
  if (isBendahara()) return '/admin/payment';
  if (isAdminEvent()) return '/admin/contingent';
  return isPanitia() ? '/admin' : '/admin/turnamen-saya';
}

/** Alamat panel yang boleh dibuka bendahara. */
export function bolehDibukaBendahara(path) {
  return /^\/admin\/(keuangan|payment)(\/|$)/.test(path);
}

/**
 * Alamat panel yang boleh dibuka admin event: Data Kontingen, Data Atlet
 * (termasuk tambah, ubah, impor, salin), Status Pendaftaran, Ketersediaan Kelas, dan cetak ID card
 * kejuaraannya (dibuka dari tombol di Data Atlet). Menu lain
 * hanya untuk super admin.
 */
export function bolehDibukaAdminEvent(path) {
  return /^\/admin\/(contingent|team-members|status-pendaftaran|ketersediaan-kelas|id-card)(\/|$)/.test(path);
}
